function initSlider(currentPage) {
	let $invest = currentPage.find('.invest');
	let $slider = $invest.find('.invest__slider');
	let $slide = $slider.find('.invest__slide');

	let slidesCount = $slide.length;

	$slider
		.on('init', () => {
			$slide.each((index, slide) => {
				$(slide)
					.attr('data-slide', index + 1)
					.find('.invest__count').text(`${index + 1}/${slidesCount}`);
			});
		})
		.on('afterChange', () => {
			let name = $slider.find('.slick-current .invest__subtitle').text();

			$(document).trigger('invest-next', [name]);
		});

	$slider.slick({
		adaptiveHeight: true,
		infinite: false,
	});
}

export default {
	initSlider,
};
